import { Customer, CustomerSigner } from '@prisma/client';

export const getCombinedCustomerName = (customer: Customer) => {
  if (customer.customer2FirstName) {
    if (
      customer.customer2LastName.toLowerCase() ===
      customer.customer1LastName.toLowerCase()
    ) {
      return `${customer.customer1Title} et ${customer.customer2Title} ${customer.customer1LastName}`;
    }
    return `${customer.customer1Title} ${customer.customer1LastName} et ${customer.customer2Title} ${customer.customer2LastName}`;
  }
  return `${customer.customer1Title} ${customer.customer1LastName}`;
};

export const getCustomer1Name = (customer: Customer) => {
  return `${customer.customer1Title} ${customer.customer1FirstName} ${customer.customer1LastName}`;
};

export const getCustomer2Name = (customer: Customer) => {
  return `${customer.customer2Title} ${customer.customer2FirstName} ${customer.customer2LastName}`;
};

export const hasCustomer2 = (customer: Customer) => {
  return !!customer.customer2FirstName && !!customer.customer2LastName;
};

export const getSignerFullName = (customer: Customer) => {
  const signerNames = {
    [CustomerSigner.CLIENT1]: `${customer.customer1Title} ${customer.customer1FirstName} ${customer.customer1LastName} - ${customer.customer1Email}`,
    [CustomerSigner.CLIENT2]: `${customer.customer2Title} ${customer.customer2FirstName} ${customer.customer2LastName} - ${customer.customer2Email}`,
  };
  return signerNames[customer.signer];
};

export const getCustomerEmail = (customer: Customer) => {
  return customer.signer === CustomerSigner.CLIENT1
    ? customer.customer1Email
    : customer.customer2Email;
};
